module.exports = __webpack_public_path__ + "static/media/bubbles.22452e75.mp3";